export default __webpack_public_path__ + "static/media/img_08.8c128700.jpg";